import React from 'react';
import { GroupBase, MenuListProps, OptionProps, components } from 'react-select';
import TinyList from 'react-tiny-virtual-list';

// performans ve virtual list ile çakışmaması için onMouseMove ve onMouseOver eventlerini kaldırır
export const CustomOption = <OptionType, IsMulti extends boolean = false>(
  props: OptionProps<OptionType, IsMulti, GroupBase<OptionType>>
) => {
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };
  return <components.Option {...newProps}>{props?.children}</components.Option>;
};

// react-select için virtual list kullanımı
// Option sayısı çok fazla olduğunda performansı artırmak için kullanılır
// Her item'ın gerçek yüksekliği ölçülerek variable-height virtual list oluşturulur
export const MenuList = <OptionType, IsMulti extends boolean = false>(
  props: MenuListProps<OptionType, IsMulti, GroupBase<OptionType>>
) => {
  const { children, maxHeight } = props;
  const defaultItemHeight = 36;
  const childrenArray = React.Children.toArray(children);
  const itemCount = childrenArray?.length || 0;
  const [itemHeights, setItemHeights] = React.useState<number[]>([]);
  const measureRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    if (!measureRef.current || itemCount === 0) return;
    const heights = Array.from(measureRef.current.children).map(
      (child) => (child as HTMLElement).offsetHeight
    );
    setItemHeights((prev) => {
      if (prev.length === heights.length && prev.every((h, i) => h === heights[i])) return prev;
      return heights;
    });
  }, [children, itemCount]);

  if (!itemCount) {
    return <components.MenuList {...props}> {children} </components.MenuList>;
  }

  const hasHeights = itemHeights.length === itemCount;
  const totalHeight = hasHeights
    ? itemHeights.reduce((sum, h) => sum + h, 0)
    : itemCount * defaultItemHeight;

  return (
    <div style={{ position: 'relative' }}>
      {/* Gerçek yükseklikleri ölçmek için gizli div */}
      <div
        ref={measureRef}
        aria-hidden="true"
        style={{ position: 'absolute', visibility: 'hidden', pointerEvents: 'none', width: '100%', top: 0, left: 0, zIndex: -1 }}
      >
        {childrenArray.map((child, index) => (
          <div key={index}>{child}</div>
        ))}
      </div>
      <div className="py-1">
        <TinyList
          height={Math.min(maxHeight, totalHeight)}
          itemCount={itemCount}
          itemSize={hasHeights ? (index) => itemHeights[index] : defaultItemHeight}
          width="100%"
          renderItem={({ index, style }) => (
            <div style={{ ...style, overflow: 'hidden' }}>{childrenArray[index]}</div>
          )}
        />
      </div>
    </div>
  );
};

// Türkçe karakterlere duyarlı react-select bileşeni için filtreleme fonksiyonu
export const turkishFilterOption = ({ label }: { label: string }, inputValue: string) => {
  const labelNormalized = label.toLocaleLowerCase('tr');
  const inputNormalized = inputValue.toLocaleLowerCase('tr');
  return labelNormalized.includes(inputNormalized);
}